/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type GetModuleUpgradeOfferPreviewParams = {
  /**
   * Published version the draft is based on; default preview group
   */
  source_version?: string | null;
};
